import { request } from '@/utils/ajax';
import type { OptionPresetItemDto, PresetItemUpdateDto } from './option-preset-item.types';

export function getOptionPresetItems(presetId: number): Promise<OptionPresetItemDto[]> {
    return request(`api/option-preset/${presetId}/items`, {}).then((x) => x.json());
}

export function updateOptionPresetItems(presetId: number, items: PresetItemUpdateDto[]): Promise<any> {
    return request(`api/option-preset/${presetId}/items`, {
        method: 'PUT',
        json: true,
        body: items,
    });
}
